<app-top-menu></app-top-menu>
<div class="bg-login">
    <div class="container">
        <div class="row popeye justify-content-center">
            <div class="col-md-5 tax-payee">
                    <h6 class="mt-4 mb-4" style="text-align: center">Tax Payer Login</h6>
                    <div class="tax-div">

                        <form [formGroup]="form" (ngSubmit)="LoginUser()">
                            <div class="form-group mb-4">
                                <label>
                                    <small>Email / ASIN</small>
                                    <input
                                        class="form-control"
                                        placeholder="Email / ASIN"
                                        formControlName="email"
                                        type="email"
                                        [ngClass]="{ 'is-invalid': form.controls.email.touched && form.controls.email.invalid && form.controls.email.errors?.required, 'form-control': true }"
                                    />
                                </label>
                            </div>

                            <div class="form-group">
                                <label>
                                    <small>Password</small>
                                    <input
                                        class="form-control"
                                        formControlName="password"
                                        id="password"
                                        type="password"
                                        placeholder="Password"
                                        [ngClass]="{ 'is-invalid': form.controls.password.invalid && form.controls.password.touched && form.controls.password.errors?.required, 'form-control': true }"
                                    />
                                </label>
                            </div>

                            <div class="d-flex justify-content-end">
                                <label>
                                    <div class="form-check form-switch mb-2">
                                        <input type="checkbox" id="togglePassword" formControlName="togglePassword" [value]="showPassword" (change)="togglePassword()" class="form-check-input me-2">
                                        <label class="form-check-label me-2">Show Password</label>
                                    </div>
                                </label>
                            </div>

                            <div class="form-group my-2">
                                <label>
                                    <a href="#" routerLink="/auth/forgot">Forgot password?</a>
                                </label>
                            </div>

                            <div class=" mb-4">
                                <button class="btn btn-block btn-warning" type="submit">
                                    <b *ngIf="!login" >Login</b>
                                    <b *ngIf="login"  class="spinner-border text-dark"></b>
                                </button>
                            </div>

                        </form>

                    </div>
                    <!-- <app-captcha></app-captcha> -->
                </div>

        </div>

    </div>
</div>


